import { getCurrencySymbol, numericUtil } from '@cmg/common';
import { createValueFormatter } from '@cmg/data-grid';
import defaultTo from 'lodash/defaultTo';
import isNil from 'lodash/isNil';

import type { CalendarGridColDef, CalendarGridRowData } from '../../CalendarGrid.model';

export type Value = NonNullable<CalendarGridRowData['attributes']>['marketCapAtPricing'];

export const valueFormatter = createValueFormatter<CalendarGridRowData, Value>({
  gridRow: ({ value, data }) => {
    const currencyCode = defaultTo(data?.attributes?.pricingCurrency, 'USD');

    if (isNil(value)) {
      return '-';
    }

    return numericUtil.formatCurrencyInMillions(value, true, getCurrencySymbol(currencyCode));
  },
});

const marketCapPostOfferingColDef: CalendarGridColDef<Value> = {
  field: 'attributes.marketCapAtPricing',
  headerName: 'Market Cap Post-Offering',
  width: 137,
  type: ['numericColumn', 'number'],
  filter: false,
  sortable: false,
  valueFormatter,
};

export default marketCapPostOfferingColDef;
